import { useEffect } from "react";
import { motion } from "framer-motion";
import Header from "./components/Header";
import Services from "./components/Services";
import ProcessCarousel from "./components/ProcessCarousel";
import FAQ from "./components/FAQ";
import CTASection from "./components/CTASection";
import TopBar from "./components/TopBar"; 

function App() {
  useEffect(() => {
    const timeout = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    }, 100);

    return () => clearTimeout(timeout);
  }, []);

  const sectionVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.8 } },
  };

  return (
    <>
      <TopBar />
      <div className="mt-7"> {/* Ajusta el margen superior */}
        <motion.div initial="hidden" animate="visible" variants={sectionVariants}>
          <Header />
        </motion.div>
        {/* <motion.div initial="hidden" animate="visible" variants={sectionVariants}>
          <Services />
        </motion.div> */}
        {/* <motion.div initial="hidden" animate="visible" variants={sectionVariants}>
          <ProcessCarousel />
        </motion.div>
        <motion.div initial="hidden" animate="visible" variants={sectionVariants}>
          <FAQ />
        </motion.div>
        */}
        {/* <motion.div initial="hidden" animate="visible" variants={sectionVariants}>
          <CTASection />
        </motion.div>  */}
      </div>
    </>
  );
}

export default App;
